// src/MainAppStyles.ts
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

/**
 * Если вы НЕ хотите принимать кастомные пропы (например, isOpen),
 * тогда можно просто делать styled(Box) без расширения.
 * Но если где-то делаете <OuterContainer isOpen={...} />, нужно объявить интерфейс.
 */
export const OuterContainer = styled(Box)(() => ({
  display: "flex",
  minHeight: "100vh",
  // backgroundColor: theme.palette.background.regular,
}));

export const MainContent = styled(Box)(() => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
}));

export const ContentSection = styled(Box)(({ theme }) => ({
  flex: 1,
  // Пример "20px" через theme.spacing(2.5)
  paddingBottom: theme.spacing(2.5),
  // backgroundColor: theme.palette.background.elements,
}));
